module.exports = __webpack_public_path__ + "static/media/GERONA.b12c15a2.png";